import { FilterConfig } from '@10d/tend-ui/components/Filters';

import { get } from 'api/requests';

import { BOOLEAN_SELECT, PLACEMENT_KIND } from 'consts/filtersValue';

import { ABSENT_OPTIONS } from './ABSENT_OPTIONS';
import { FilterKeys } from './FilterKeys';
import { buildRepeatedQueryString, joinStructure, transformOption } from '../utils';
import {
  FINISHING_FILTER,
  FINISHING_OPTIONS_FILTER,
  MKD,
  PROJECT_MKD_FILTER,
  STAGE_FILTER,
  STATE_THE_ROOM_FILTER,
  STATUS_SCS_FILTER,
  STRUCTURE_FILTER,
} from 'consts';

export const filterConfig: FilterConfig[] = [
  {
    key: FilterKeys.Project,
    id: FilterKeys.Project,
    name: FilterKeys.Project,
    label: 'Проект',
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: true,
      placeholder: 'Выберите',
      preload: ['onmount'],
      pagination: true,
      api: {
        fn: reqParams => get(PROJECT_MKD_FILTER.apiUrl, reqParams?.params).then(({ data }) => data),
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.Structure,
    id: FilterKeys.Structure,
    name: FilterKeys.Structure,
    label: 'Объект',
    depends: [FilterKeys.Project],
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: true,
      placeholder: 'Выберите',
      preload: ['onmount'],
      pagination: true,
      api: {
        fn: reqParams => {
          const { projects, search } = reqParams?.params || {};
          const query = buildRepeatedQueryString('projects', projects);
          const url = query ? `${STRUCTURE_FILTER.apiUrl}&${query}` : STRUCTURE_FILTER.apiUrl;

          return get(url, { search }).then(({ data }) => data);
        },
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.Section,
    id: FilterKeys.Section,
    name: FilterKeys.Section,
    label: 'Секция',
    depends: [FilterKeys.Project, FilterKeys.Structure],
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: true,
      placeholder: 'Выберите',
      preload: ['onmount'],
      pagination: true,
      api: {
        fn: reqParams => {
          const { structures, search } = reqParams?.params || {};

          return get('/api/standards/sections/', {
            structure: joinStructure(structures),
            search,
          }).then(({ data }) => ({
            next: null,
            results: data,
          }));
        },
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.PlacementKind,
    id: FilterKeys.PlacementKind,
    name: FilterKeys.PlacementKind,
    label: 'Тип помещения',
    component: {
      component: 'select',
      mode: 'multiple',
      allowClear: true,
      showSearch: false,
      placeholder: 'Выберите',
      options: PLACEMENT_KIND,
    },
  },
  {
    key: FilterKeys.Status,
    id: FilterKeys.Status,
    name: FilterKeys.Status,
    label: 'Статус (текущий)',
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: false,
      placeholder: 'Выберите',
      preload: ['onmount'],
      api: {
        fn: () => get(STATUS_SCS_FILTER().apiUrl).then(({ data }) => data),
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.Stage,
    id: FilterKeys.Stage,
    name: FilterKeys.Stage,
    label: 'Этап проверки',
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: false,
      placeholder: 'Выберите',
      preload: ['onmount'],
      api: {
        fn: () => get(STAGE_FILTER().apiUrl).then(({ data }) => data),
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.Finishing,
    id: FilterKeys.Finishing,
    name: FilterKeys.Finishing,
    label: 'Наличие отделки',
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: false,
      placeholder: 'Выберите',
      preload: ['onmount'],
      api: {
        fn: () => get(FINISHING_FILTER.apiUrl).then(({ data }) => data),
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.Options,
    id: FilterKeys.Options,
    name: FilterKeys.Options,
    label: 'Опции',
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: true,
      placeholder: 'Выберите',
      preload: ['onmount'],
      pagination: true,
      api: {
        fn: reqParams =>
          get(
            FINISHING_OPTIONS_FILTER(reqParams?.params.finishing, MKD).apiUrl,
            reqParams?.params,
          ).then(({ data }) => data),
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.AbsentOptions,
    id: FilterKeys.AbsentOptions,
    name: FilterKeys.AbsentOptions,
    label: 'Отсутствующие опции',
    component: {
      component: 'select',
      mode: 'multiple',
      allowClear: true,
      showSearch: false,
      placeholder: 'Выберите',
      options: ABSENT_OPTIONS,
    },
  },
  {
    key: FilterKeys.ReadyForCall,
    id: FilterKeys.ReadyForCall,
    name: FilterKeys.ReadyForCall,
    label: 'Готово к вызову',
    component: {
      component: 'select',
      allowClear: true,
      placeholder: 'Выберите',
      options: BOOLEAN_SELECT,
    },
  },
  {
    key: FilterKeys.StatusCode,
    id: FilterKeys.StatusCode,
    name: FilterKeys.StatusCode,
    label: 'Состояние помещения',
    component: {
      component: 'async-select',
      mode: 'multiple',
      allowClear: true,
      showSearch: true,
      placeholder: 'Выберите',
      preload: ['onmount'],
      pagination: true,
      api: {
        fn: reqParams =>
          get(STATE_THE_ROOM_FILTER.apiUrl, reqParams?.params).then(({ data }) => data),
      },
      transform: transformOption,
    },
  },
  {
    key: FilterKeys.HasApp,
    id: FilterKeys.HasApp,
    name: FilterKeys.HasApp,
    label: 'Подписан АПП',
    component: {
      component: 'select',
      allowClear: true,
      placeholder: 'Выберите',
      options: BOOLEAN_SELECT,
    },
  },
  {
    key: FilterKeys.Period,
    id: FilterKeys.Period,
    name: FilterKeys.Period,
    label: 'Период (по дате статуса)',
    component: {
      component: 'range-picker',
      allowClear: true,
    },
  },
];
